<template>
	<modal
		:exibir="exibir"
		:titulo="tituloModal"
		:max-width="modalOptions.largura"
		@close="fecharModal"
		:custom-actions="true"
		cor-do-botao-confirmar="error"
		:acao-cancelar="fecharModal"
		:acao-confirmar="confirmar"
		nome-botao-confirmar="Confirmar"
	>
		<template #title>
			<v-card-title class="d-flex justify-center mt-3 text-h5">
				<v-icon id="iconeModal" size="80" :color="corIcone" class="mb-2">{{ iconeModal }}</v-icon>
				<span class="texto-titulo">
					<b>{{ tituloModal }}</b>
				</span>
				<v-spacer></v-spacer>
			</v-card-title>
		</template>

		<template #body>
			<v-row dense class="az-form-content cp-modal-form-content justify-center mensagem-modal">
				<span class="texto-corpo">{{ subtituloModal }}</span>
				<h4 class="mt-2 texto-confirmacao">{{ mensagem }}</h4>
			</v-row>
		</template>

		<template #actions>
			<v-card-actions class="mb-3 mt-3 pb-2 pt-2">
				<v-row no-gutters justify="center">
					<slot name="acoes">
						<botao-primario
							tamanho-largura="100"
							:nome-botao="labelAcaoCancelar"
							class="mr-5"
							@click="fecharModal"
						></botao-primario>
						<botao-cancelar
							tamanho-largura="100"
							v-if="mostrarAcaoConfirmar"
							:label="labelAcaoConfirmar"
							@cancelar="confirmar"
						></botao-cancelar>
					</slot>
				</v-row>
			</v-card-actions>
		</template>
	</modal>
</template>

<script>
export default {
	name: 'modal-confirmacao',
	props: {
		exibir: {
			type: Boolean,
		},
		iconeModal: {
			type: String,
			default: 'error_outline',
		},
		corIcone: {
			type: String,
			default: '#FF9900',
		},
		labelAcaoConfirmar: {
			type: String,
			default: 'SIM',
		},
		labelAcaoCancelar: {
			type: String,
			default: 'NÃO',
		},
		tituloModal: {
			type: String,
			required: true,
		},
		subtituloModal: {
			type: String,
			default: '',
		},
		mensagem: {
			type: String,
			default: '',
		},
		mostrarAcaoConfirmar: {
			type: Boolean,
			default: true,
		},
	},
	emits: ['fechar-modal', 'confirmar'],
	data() {
		return {
			modalOptions: {
				largura: '500',
			},
		}
	},
	methods: {
		fecharModal() {
			this.$emit('fechar-modal')
		},
		async confirmar() {
			await this.$emit('confirmar')
		},
	},
}
</script>

<style lang="stylus" scoped>
.v-dialog
	.texto-titulo
		color #404040
		width 98%
		text-align center
		margin-left 18px
		margin-right 17px
		font-weight 700
		font-size 22px
		line-height 26px

	.close-modal-mobile
		position absolute !important
		right 20px !important

	.mensagem-modal
		display grid !important

	.v-card__title
		word-break break-word

	.texto-corpo
		color #4B4B4B
		font-size 18px
		font-weight 400
		text-align center
		font-style normal
		line-height 25px

	.texto-confirmacao
		color #726f6f
		font-size 18px
		font-weight 400
		text-align center
		font-style normal
		line-height 25px
</style>
